interface CardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({ title, subtitle, children, className = '', onClick }: CardProps) {
  const interactive = typeof onClick === 'function';

  return (
    <div
      className={`bg-bg-secondary border border-border-subtle rounded-lg p-4 ${
        interactive ? 'hover:border-border-hover cursor-pointer transition-colors' : ''
      } ${className}`}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      {title ? (
        <div className="mb-3">
          <h3 className="text-sm font-medium text-text-primary">{title}</h3>
          {subtitle ? <p className="text-xs text-text-muted mt-0.5">{subtitle}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}

export default Card;
